import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import axios from "axios";
import { StatusEnum } from "../../constants/employeeStatusEnum";
import StatusOptions from "../../options/employeeStatusOptions";
import {
  findProjectDesignationOption,
  useProjectDesignationOptions,
} from "../../Hooks/useProjectDesignationOptions";
import { designationOptionsForType, projectDesignationTypeOptions } from "../../Hooks/projectDesignationTypes";
import { performanceLensRoleSelectOptions } from "../../Hooks/performanceLensRoleOptions";
import { Select as V2Select } from "../../v2/components/ui/select/select.tsx";
import "../../Styles/projectMemberForm.css";
import { ThreeDots } from "react-loader-spinner";
import DeallocateShadowMember from "./DeallocateShadowMember";
import { API_SHADOW_RESOURCES } from "../../config/Endpoints";
export const EditMemberFormModal = ({
  openModal,
  closeModal,
  updateMember,
  project,
  shadowEmployeeList,
  mainEmployeeList,
  expertiseOptions,
  isExpertiseLoading,
  formData,
  setFormData,
  isLoading,
  isFormChanged,
}) => {
  const { options: designationOptions, loading: isDesignationLoading } = useProjectDesignationOptions();
  const calculateStatus = (joinDate, endDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);
      return end >= today ? StatusEnum.ACTIVE : StatusEnum.INACTIVE;
    }

    return joinDate ? StatusEnum.ACTIVE : "";
  };
  if (!openModal) return;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content rounded-lg">
          <div className="modal-header">
            <h5 className="modal-title">Edit Shadow Member</h5>
            <button
              type="button"
              className="btn-close"
              onClick={closeModal}
            ></button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateMember();
            }}
          >
            <div
              className="modal-body py-5 px-4 project-member-form"
              style={{ backgroundColor: "#fafbff" }}
            >
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    {/* Shadow Employee */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0"
                          style={{ color: "#333" }}
                        >
                          Shadow Employee
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={shadowEmployeeList}
                          placeholder="Select Shadow Employee"
                          value={formData.shadowEmployee}
                          onChange={(val) =>
                            setFormData({ ...formData, shadowEmployee: val, locationType: "", designation: null, performanceRoleCode: "" })
                          }
                          required
                        />
                      </div>
                    </div>

                    {/* Main Employee */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          Main Employee
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={mainEmployeeList}
                          placeholder="Select Main Employee"
                          value={formData.mainEmployee}
                          onChange={(val) =>
                            setFormData({ ...formData, mainEmployee: val })
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4"><label className="form-label mb-0">Designation Type</label></div>
                      <div className="col-md-8">
                        <Select
                          placeholder="Select Onshore or Offshore"
                          options={projectDesignationTypeOptions}
                          value={projectDesignationTypeOptions.find((option) => option.value === formData.locationType) || null}
                          onChange={(option) => setFormData({ ...formData, locationType: option?.value || "", designation: null, performanceRoleCode: "" })}
                          isDisabled={!formData.shadowEmployee}
                          isClearable
                        />
                      </div>
                    </div>

                    {/* Designation */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          Designation
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={designationOptionsForType(designationOptions, formData.locationType)}
                          placeholder={isDesignationLoading ? "Loading Designations" : "Select Designation"}
                          isDisabled={isDesignationLoading || !formData.locationType}
                          value={designationOptionsForType(designationOptions, formData.locationType)
                            .find((option) => option.value === formData.designation?.value) || null}
                          onChange={(option) =>
                            setFormData({ ...formData, designation: option, performanceRoleCode: "" })
                          }
                        />
                      </div>
                    </div>

                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4"><label className="form-label mb-0" htmlFor="edit-shadow-performance-role-trigger">Performance Role</label></div>
                      <div className="col-md-8"><V2Select id="edit-shadow-performance-role" value={formData.performanceRoleCode || ""}
                        onChange={(value) => setFormData((current) => ({ ...current, performanceRoleCode: value }))}
                        options={performanceLensRoleSelectOptions(formData.designation)} placeholder="Select performance role"
                        disabled={!formData.designation?.performanceRoles?.length} required={Boolean(formData.designation?.performanceRoles?.length)} /></div>
                    </div>

                    {/* Project Expertise */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0"
                          style={{ color: "#333" }}
                        >
                          Project Expertise
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          placeholder={
                            isExpertiseLoading
                              ? "Loading Project Expertise"
                              : "Select Project Expertise"
                          }
                          options={expertiseOptions}
                          value={formData.expertise}
                          onChange={(option) =>
                            setFormData({ ...formData, expertise: option })
                          }
                          isLoading={isExpertiseLoading}
                          isDisabled={isExpertiseLoading}
                          isSearchable
                          isClearable
                        />
                      </div>
                    </div>

                    {/* Joining Date */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0"
                          style={{ color: "#333" }}
                        >
                          Joining Date
                        </label>
                      </div>
                      <div className="col-md-8">
                        <DatePicker
                          showIcon
                          toggleCalendarOnIconClick
                          placeholderText="mm/dd/yyyy"
                          selected={
                            formData.joiningDate
                              ? new Date(formData.joiningDate)
                              : null
                          }
                          minDate={
                            project?.sowStartDate
                              ? new Date(project.sowStartDate)
                              : null
                          }
                          maxDate={
                            project?.sowEndDate
                              ? new Date(project.sowEndDate)
                              : null
                          }
                          onChange={(date) =>
                            setFormData({
                              ...formData,
                              joiningDate: date,
                              status: StatusOptions.find(
                                (opt) =>
                                  opt.value ===
                                  calculateStatus(date, formData.endDate)
                              ),
                            })
                          }
                          required
                          onKeyDown={(e) => {
                            if (e.key !== "Backspace" && e.key !== "Delete")
                              e.preventDefault();
                          }}
                          className="border"
                          style={{
                            borderColor: "#e1e5f7",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            fontSize: "14px",
                            backgroundColor: "#fff",
                          }}
                        />
                      </div>
                    </div>

                    {/* End Date */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          End Date
                        </label>
                      </div>
                      <div className="col-md-8">
                        <DatePicker
                          showIcon
                          toggleCalendarOnIconClick
                          placeholderText="mm/dd/yyyy"
                          selected={
                            formData.endDate ? new Date(formData.endDate) : null
                          }
                          minDate={
                            formData.joiningDate
                              ? new Date(formData.joiningDate)
                              : project?.sowStartDate
                              ? new Date(project.sowStartDate)
                              : null
                          }
                          maxDate={
                            project?.endDate
                              ? new Date(project.endDate)
                              : project?.sowEndDate
                              ? new Date(project.sowEndDate)
                              : null
                          }
                          onChange={(date) =>
                            setFormData({
                              ...formData,
                              endDate: date,
                              status: StatusOptions.find(
                                (opt) =>
                                  opt.value ===
                                  calculateStatus(formData.joiningDate, date)
                              ),
                            })
                          }
                          onKeyDown={(e) => {
                            if (e.key !== "Backspace" && e.key !== "Delete")
                              e.preventDefault();
                          }}
                          className="border"
                          style={{
                            borderColor: "#e1e5f7",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            fontSize: "14px",
                            backgroundColor: "#fff",
                          }}
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          Status
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={StatusOptions}
                          value={formData.status || null}
                          onChange={(option) =>
                            setFormData({ ...formData, status: option })
                          }
                          placeholder="Select Status"
                          isDisabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer rounded-lg-bottom">
              <button
                type="button"
                className="btn btn-secondary px-4 py-2"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn theme-button"
                disabled={isLoading || !isFormChanged}
              >
                {isLoading ? (
                  <ThreeDots
                    height="25"
                    width="80"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                ) : (
                  "Save Changes"
                )}
              </button>
              <DeallocateShadowMember
                memberForm={formData}
                updateMember={updateMember}
                closeMemberModal={closeModal}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const EditMembers = ({
  project,
  memberData,
  closeModal,
  openModal,
  shadowEmployeeList,
  mainEmployeeList,
  expertiseOptions,
  isExpertiseLoading,
  onMemberUpdate,
}) => {
  const { options: designationOptions } = useProjectDesignationOptions();
  const [isLoading, setIsLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [formData, setFormData] = useState({
    shadowEmployee: memberData?.shadowEmployeeId
      ? {
          value: memberData.shadowEmployeeId,
          label: memberData.shadowEmployeeName,
        }
      : null,
    mainEmployee: memberData?.workingEmployeeId
      ? {
          value: memberData.workingEmployeeId,
          label: memberData.workingEmployeeName,
        }
      : null,
    joiningDate: memberData?.joiningDate
      ? new Date(memberData.joiningDate)
      : null,
    endDate: memberData?.endDate ? new Date(memberData.endDate) : null,
    status:
      memberData?.status !== undefined
        ? StatusOptions.find((opt) => opt.value === memberData.status)
        : null,
    designation: memberData?.designation
      ? findProjectDesignationOption(memberData.designation, designationOptions) || null
      : null,
    performanceRoleCode: memberData?.performanceRoleCode || "",
    locationType: findProjectDesignationOption(memberData?.designation, designationOptions)?.locationType || "",
    expertise: memberData?.expertise
      ? { value: memberData.expertise, label: memberData.expertise }
      : null,
  });

  const [initialFormData, setInitialFormData] = useState({
    shadowEmployee: memberData?.shadowEmployeeId
      ? {
          value: memberData.shadowEmployeeId,
          label: memberData.shadowEmployeeName,
        }
      : null,
    mainEmployee: memberData?.workingEmployeeId
      ? {
          value: memberData.workingEmployeeId,
          label: memberData.workingEmployeeName,
        }
      : null,
    joiningDate: memberData?.joiningDate
      ? new Date(memberData.joiningDate)
      : null,
    endDate: memberData?.endDate ? new Date(memberData.endDate) : null,
    status:
      memberData?.status !== undefined
        ? StatusOptions.find((opt) => opt.value === memberData.status)
        : null,
    designation: memberData?.designation
      ? findProjectDesignationOption(memberData.designation, designationOptions) || null
      : null,
    performanceRoleCode: memberData?.performanceRoleCode || "",
    locationType: findProjectDesignationOption(memberData?.designation, designationOptions)?.locationType || "",
    expertise: memberData?.expertise
      ? { value: memberData.expertise, label: memberData.expertise }
      : null,
  });
  useEffect(() => {
    if (!memberData?.designation || !designationOptions.length) return;
    const option = findProjectDesignationOption(memberData.designation, designationOptions);
    if (!option) return;
    setFormData((previous) => previous.designation ? previous : { ...previous, designation: option, locationType: option.locationType });
    setInitialFormData((previous) => previous.designation ? previous : { ...previous, designation: option, locationType: option.locationType });
  }, [designationOptions, memberData?.designation]);
  const isFormChanged =
    JSON.stringify(formData) !== JSON.stringify(initialFormData);

  const toUTCDateString = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00:00`;
  };

  const updateMember = async (
    updatedForm = null,
    triggerMainLoading = true
  ) => {
    try {
      if (triggerMainLoading) setIsLoading(true);
      const formToSend = updatedForm || formData;

      const unchangedLegacyDesignation = !formToSend.designation && !formToSend.locationType &&
        Boolean(memberData?.designation);
      if (!unchangedLegacyDesignation && (!formToSend.locationType || !formToSend.designation ||
          formToSend.designation.locationType !== formToSend.locationType)) {
        toast.error("Select a designation type and designation.");
        return;
      }
      if (formToSend.designation?.performanceRoles?.length && !formToSend.performanceRoleCode) {
        toast.error("Select a Performance Lens role.");
        return;
      }

      if (formToSend.joiningDate && formToSend.endDate) {
        const join = new Date(formToSend.joiningDate);
        const end = new Date(formToSend.endDate);
        join.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        if (end < join) {
          toast.error("End date must be after or equal to joining date!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          if (triggerMainLoading) setIsLoading(false);
          return;
        }
      }

      const payload = {
        shadowEmployeeId: formToSend.shadowEmployee?.value,
        workingEmployeeId: formToSend.mainEmployee?.value,
        projectId: project?.projectId,
        joiningDate: toUTCDateString(formToSend.joiningDate),
        endDate: toUTCDateString(formToSend.endDate),
        status: formToSend.status?.value,
        designation: formToSend.designation?.legacyValue ?? null,
        globalDesignationId: formToSend.designation?.id ?? null,
        performanceRoleCode: formToSend.performanceRoleCode || null,
        expertise: String(formToSend.expertise?.value || ""),
        createdBy: String(userData?.id),
      };

      const accessToken = Cookies.get("accessToken");

      const res = await axios.put(
        `${API_SHADOW_RESOURCES}/${memberData.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status >= 200 && res.status < 300) {
        toast.success(res?.data?.message || "Member updated successfully");

        onMemberUpdate({
          ...memberData,
          shadowEmployeeId: formToSend.shadowEmployee?.value,
          shadowEmployeeName: formToSend.shadowEmployee?.label,
          workingEmployeeId: formToSend.mainEmployee?.value,
          workingEmployeeName: formToSend.mainEmployee?.label,
          joiningDate: toUTCDateString(formToSend.joiningDate),
          endDate: toUTCDateString(formToSend.endDate),
          status: formToSend.status?.value,
          designation: formToSend.designation?.value ?? memberData.designation,
          globalDesignationId: formToSend.designation?.id ?? memberData.globalDesignationId ?? null,
          performanceRoleCode: formToSend.performanceRoleCode || null,
          expertise: String(formToSend.expertise?.value || ""),
        });
        if (triggerMainLoading) closeModal();
        return true;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update member.");
      throw error;
    } finally {
      if (triggerMainLoading) setIsLoading(false);
    }
  };

  return (
    <EditMemberFormModal
      openModal={openModal}
      closeModal={closeModal}
      updateMember={updateMember}
      project={project}
      formData={formData}
      setFormData={setFormData}
      shadowEmployeeList={shadowEmployeeList}
      mainEmployeeList={mainEmployeeList}
      expertiseOptions={expertiseOptions}
      isExpertiseLoading={isExpertiseLoading}
      isLoading={isLoading}
      isFormChanged={isFormChanged}
    />
  );
};
